'use client';

import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { ConfirmationModalStandard } from '@/components/ui/extended/confirm-modal-standard';
import { MoreVertical, Trash2 } from 'lucide-react';
import { useState } from 'react';
interface PaymentCardProps {
  title: string;
  identifier: string;
  isVerified?: boolean;
  className?: string;
  icon: React.ReactNode;
  onDelete?: () => void;
  onClick?: () => void;
}
export default function PaymentCard({
  title,
  identifier,
  isVerified = false,
  className = '',
  icon,
  onDelete,
  onClick
}: PaymentCardProps) {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const handleDeleteClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setIsDeleteDialogOpen(true);
  };
  const handleConfirmDelete = () => {
    onDelete?.();
    setIsDeleteDialogOpen(false);
  };
  return <>
      <Card className={`p-4 ${className} w-full`} onClick={onClick} data-sentry-element="Card" data-sentry-source-file="bank-card.tsx">
        <div className="flex w-full cursor-pointer items-center justify-between">
          <div className="flex items-center gap-3">
            <div className=" size-10 h-full items-center justify-center rounded-full">
              {icon}
            </div>
            <div className="space-y-1">
              <p className="font-medium leading-none">{title}</p>
              <p className="text-sm text-muted-foreground">{identifier}</p>
              {isVerified && <div className="flex items-center gap-1 text-emerald-600">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                    <path d="M5.475 8.275L8.3 5.45L7.5875 4.7375L5.475 6.85L4.425 5.8L3.7125 6.5125L5.475 8.275ZM6 11.5C4.84167 11.2083 3.8855 10.5437 3.1315 9.506C2.3775 8.46833 2.00033 7.31633 2 6.05V3L6 1.5L10 3V6.05C10 7.31667 9.623 8.46883 8.869 9.5065C8.115 10.5442 7.15867 11.2087 6 11.5Z" fill="#097937" />
                  </svg>
                  <span className="text-xs">Verified</span>
                </div>}
            </div>
          </div>
          <DropdownMenu data-sentry-element="DropdownMenu" data-sentry-source-file="bank-card.tsx">
            <DropdownMenuTrigger asChild data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="bank-card.tsx">
              <Button variant="ghost" size="icon" className="size-8" data-sentry-element="Button" data-sentry-source-file="bank-card.tsx">
                <MoreVertical className="size-4" data-sentry-element="MoreVertical" data-sentry-source-file="bank-card.tsx" />
                <span className="sr-only">More options</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent data-sentry-element="DropdownMenuContent" data-sentry-source-file="bank-card.tsx">
              <DropdownMenuItem className="flex justify-between px-3" onClick={handleDeleteClick} data-sentry-element="DropdownMenuItem" data-sentry-source-file="bank-card.tsx">
                Delete
                <Trash2 className="size-4 text-red-500" data-sentry-element="Trash2" data-sentry-source-file="bank-card.tsx" />
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </Card>

      <ConfirmationModalStandard isOpen={isDeleteDialogOpen} onClose={() => setIsDeleteDialogOpen(false)} onConfirm={handleConfirmDelete} title="Confirm Deletion" description="Are you sure you want to delete this payment method? This action cannot be undone." confirmText="Delete" cancelText="Cancel" data-sentry-element="ConfirmationModalStandard" data-sentry-source-file="bank-card.tsx" />
    </>;
}